import { Loader2 } from "lucide-react";

export default function FullScreenLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="loading-screen">
      <Loader2 className="h-8 w-8 animate-spin text-primary" strokeWidth={2} />
    </div>
  );
}
